import { FETCH_FAQ } from './constants'

const initialState = {
  faq: { PK: '', name: '', val: '' },
  isFetching: true,
  error: ''
}

export default function FaqReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FAQ.REQUEST: {
      return {
        ...state,
        isFetching: true,
        error: ''
      }
    }
    case FETCH_FAQ.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        faq: action.faq
      }
    }
    case FETCH_FAQ.FAILURE: {
      return {
        ...state,
        isFetching: false,
        error: action.message
      }
    }
    default: {
      return state
    }
  }
}
